<template>
  <div class="product" :class="dynamicClasses">
    <md-card-media md-ratio="16:9" class="product__image">
      <img :src="`${image}normal`">
    </md-card-media>  
    <div class="product__addToCart">
      <md-button class="md-icon-button md-raised" @click="addToCart">
        <md-icon>shopping_cart</md-icon>
      </md-button>      
    </div>
    <div class="product__content">
      <md-card-header>
        <div class="md-layout md-gutter">
          <div class="md-layout-item text-align-left">
            <div class="md-title">{{data.name}}</div>
            <div class="md-subhead">{{data.price}}€</div>
          </div>
          <div class="product__actions md-layout-item text-align-right">
            <md-button class="md-icon-button md-raised" @click="decreases">
              <md-icon>remove</md-icon>
            </md-button>            
            <div class="product__amount">{{piece}}</div>
            <md-button class="md-icon-button md-raised" @click="increases">
              <md-icon>add</md-icon>
            </md-button>       
          </div>
        </div>        
      </md-card-header>
    </div>    
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'product',
  props: [
    'data',
  ],
  components: {
  },
  data() {
    return {
      piece: this.$props.data.pieces,
      inCart: this.$props.data.inCart
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart'
    }),
    dynamicClasses() {
      return {
        ['in-cart']: this.data.inCart
      }        
    },
    image() {
      return this.data ? this.data.image : ''
    },   
  },
  methods: {
    ...mapActions({
    }),
    increases() {
      this.piece += 1
      this.updateCart()
    },
    decreases() {
      if(this.piece > 1) {
        this.piece -= 1
      }
      this.updateCart()
    },
    updateCart() {
      let product = this.$props.data
      if(product.inCart) {
        this.addToCart()
      }
    },
    addToCart() {
      let product = this.$props.data
      //this.inCart = true
      this.$store.commit("cart/ADD_TO_CART", {...product, pieces: this.piece })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/common/components/products/product.vue